var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33",
    "data-name": "Group 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.971,
    height: 20.169,
    viewBox: "0 0 19.971 20.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1282.747,997.91H1272.8a5.042,5.042,0,0,0-5.005,5.058v10.069a5.039,5.039,0,0,0,5.005,5.043h9.961a5.043,5.043,0,0,0,5.005-5.059v-10.053A5.066,5.066,0,0,0,1282.747,997.91Zm-8.3,16.327H1271.6v-8.324h2.851Zm-1.442-9.6a1.473,1.473,0,1,1,1.457-1.474A1.482,1.482,0,0,1,1273.007,1004.633Zm10.96,9.6h-2.392V1010.2c0-.976-.126-2.226-1.441-2.226-1.346,0-1.568,1.057-1.568,2.162v4.1h-2.375v-8.324h2.217v1.121h.063a2.593,2.593,0,0,1,2.423-1.136c2.613,0,3.073,1.52,3.073,3.777v4.563Z",
    transform: "translate(-1267.797 -997.91)",
    fill: "#840094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.2470849de2172bc7c0b2942f07841669.svg";
export { ForwardRef as ReactComponent };